<script setup lang="ts">
const props = defineProps<{
  availabilityStatus: string
  reAvailabilityDate?: string | null
}>()

const {
  availabilityMessage,
  availabilityColor,
} = useAvailability(
  () => props.availabilityStatus,
  () => props.reAvailabilityDate ?? undefined,
)
</script>

<template>
  <div :class="availabilityColor">
    {{ availabilityMessage }}
  </div>
</template>
